import { CLEAR_WALLET_HISTORY, GET_WALLET_HISTORY } from "../actions/types";

const wallet = (state = [], action) => {
    switch (action.type) {
        case GET_WALLET_HISTORY:
            return action.payload;
        case CLEAR_WALLET_HISTORY:
            return [];
        default:
            return state;
    }
};

export default wallet;
